require('babel-polyfill')
const puppeteer = require('puppeteer');
const { uploadBuffertoGc } = require('./gcloud');
const path = require("path");
require('dotenv').config()

const pdfGen = async (html, format, destination) => {
  try {
    // When we have to deploy in GC we have to correct this executable path!
    let executablePath = path.join(__dirname, '../../node_modules/puppeteer/.local-chromium/linux-1002410/chrome-linux/chrome');
    let puppeteerOptions = {
      headless: true,
      args: [
        '--no-sandbox',
        '--disable-web-security',
        '--disable-features=IsolateOrigins',
        '--disable-site-isolation-trials',
        '--disable-setuid-sandbox',
      ],
    };

    if (process.env.NODE_ENV == 'development') {
      puppeteerOptions = {
        executablePath: executablePath,
        ...puppeteerOptions,
      };
    }

    const browser = await puppeteer.launch(puppeteerOptions);
    const page = await browser.newPage();
    await page.setContent(html, { waitUntil: 'networkidle0' });
    // await page.emulateMediaType("screen");
    let pdfOptions = {
      format: format,
      printBackground: true // keep this true to print logo, signature and bg-colours
    };
    const buffer = await page.pdf(pdfOptions);
    let url = uploadBuffertoGc(buffer, destination);

    await browser.close();
    return url;
  } catch (err) {
    throw err;
  }
}

module.exports = {
  pdfGen
}
